module.exports = __webpack_public_path__ + "img/RepairBook.20612ecd.png";